import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Navigation } from "lucide-react";
import { toast } from "sonner";
import { useCurrentUser } from "@/hooks/platform/useCurrentUser";
import { radiusDirectionsPath, hasDestination, type DirectionsTarget } from "@/lib/directions";

interface DirectionsButtonProps extends DirectionsTarget {
  size?: "sm" | "default" | "icon";
  variant?: "outline" | "ghost" | "secondary" | "default";
  label?: string;
  className?: string;
}

/**
 * Sends the user to the in-app Radius map with this destination preloaded,
 * so directions always happen inside Metro City Groove.
 */
const DirectionsButton = ({
  name, lat, lng, address,
  size = "sm", variant = "outline", label = "Directions", className,
}: DirectionsButtonProps) => {
  const navigate = useNavigate();
  const { userId } = useCurrentUser();
  const target: DirectionsTarget = { name, lat, lng, address };

  const go = () => {
    if (!hasDestination(target)) {
      toast.error("This listing has no verified address yet");
      return;
    }
    const path = radiusDirectionsPath(target);
    if (!userId) { navigate(`/auth?next=${encodeURIComponent(path)}`); return; }
    navigate(path);
  };

  return (
    <Button size={size} variant={variant} className={className} onClick={go} aria-label={`Directions to ${name}`}>
      <Navigation className={size === "icon" ? "w-4 h-4" : "w-3.5 h-3.5 mr-1.5"} />
      {size !== "icon" && label}
    </Button>
  );
};

export default DirectionsButton;
